import FieldDropdown from "../../../fields3/generic/dropdown/dropdown"

import FieldColor_Popover from "./components/popover/popover-menu"
import FieldColor_InlineValueEmpty from "./components/inline-edit/value-empty";
import FieldColor_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldColor_FormValueEmpty from "./components/form/value-empty"
import FieldColor_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldColor_View from "./render/view"
import FieldColor_ManagementPreview from "./render/management-preview"
import FieldColor_ManagementForm from "./render/management-form"
import FieldColor_GlistGroupModern from "./components/glist-group/modern"
import FieldColor_GlistGroupStandard from "./components/glist-group/standard"
import FieldConfig from "../../proto/field-config"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import {ColorPalette, ItemColorCoding} from "../../color-coding/color-coding"
import FieldColor_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldColor_PickerValueEmpty from "./components/picker/value-empty"
import FieldColor_ViewGroup from "./render/group/group"

export const PROJECT_COLOR_OPTIONS: Option[] = [
    {value: 27, label: 'Dark blue'},
    {value: 20, label: 'Blue'},
    {value: 6,  label: 'Light blue'},
    {value: 28, label: 'Cyan'},
    {value: 9,  label: 'Aquamarine'},
    {value: 29, label: 'Light green'},
    {value: 11, label: 'Green'},
    {value: 30, label: 'Dark green'},
    {value: 31, label: 'Lime'},
    {value: 14, label: 'Yellow'},
    {value: 15, label: 'Orange'},
    {value: 16, label: 'Light red'},
    {value: 32, label: 'Red'},
    {value: 1,  label: 'Raspberry'},
    {value: 33, label: 'Pink'},
    {value: 3,  label: 'Deep pink'},
    {value: 34, label: 'Purple'},
    {value: 35, label: 'Dark purple'},
    {value: 22, label: 'Light violet'},
    {value: 36, label: 'Violet'},
    {value: 19, label: 'Brown'},
    {value: 37, label: 'Mahogany'},
    {value: 38, label: 'Chocolate'},
    {value: 17, label: 'Black'},
]

export default class FieldColor extends FieldDropdown {

    FIELD_DEFAULT_WIDTH: number = 100;

    public noColorAllowed       : boolean   // Allow deny no color option
    public showEmptyColorPicker : boolean   // determines whether FieldPicker should show icon or empty ui5-color-picker if no color selected

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Color";
        this.filterType         = null; //'color';
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Color selector"
        this.icon               = 'i5-color';
        this.isFilterAvailable  = false

        // special
        this.options            = PROJECT_COLOR_OPTIONS //_.get(config, 'options', PROJECT_COLORS);

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','None');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.isSearchable           = true
        this.isColorCodingAvailable = true

        // Color specific

        // @ts-ignore
        this.colorPalette           = _.get(config, 'colorPalette', 'gd-c-') // this is VERY WRONG - old version new version - real pallete + style to set color
        this.noColorAllowed         = _.get(config, 'noColorAllowed', true);

        this.showEmptyColorPicker   = _.get(config, 'showEmptyColorPicker', false);


        this.components.PopoverMenu           = FieldColor_Popover

        this.components.FormValueEmpty        = FieldColor_FormValueEmpty
        this.components.FormValueNotEmpty     = FieldColor_FormValueNotEmpty

        this.components.InlineValueEmpty      = FieldColor_InlineValueEmpty
        this.components.InlineValueNotEmpty   = FieldColor_InlineValueNotEmpty

        this.components.PickerValueEmpty      = FieldColor_PickerValueEmpty
        this.components.PickerValueNotEmpty   = FieldColor_PickerValueNotEmpty

        this.components.glistGroupModern      = FieldColor_GlistGroupModern
        this.components.glistGroupStandard    = FieldColor_GlistGroupStandard



        this.renderComponents.view              = FieldColor_View
        this.renderComponents.viewSmall         = FieldColor_View

        this.renderComponents.managementPreview = FieldColor_ManagementPreview
        this.renderComponents.managementForm    = FieldColor_ManagementForm

        this.renderComponents.viewGroup         = FieldColor_ViewGroup

    }

    sortValue(value:any) {
        return _.get(this._getOption(value),'value', 0)
    }

    groupSortValue(value:any) {
        return this.sortValue(value)
    }

    toJson() {
        let result = super.toJson();

        // we DO NOT want to export options
        delete result.options

        return result;
    }

    getColorCoding(model: any): ItemColorCoding {
        const value = _.get(model, this.fieldId, null)
        // const value = gd.session.projects.get(model.id).color

        if (!_.isNil(value)) {
            return {
                colorNumber     : value,
                corePalette     : ColorPalette.CORE
            }
        } else {
            return super.getColorCoding(model)
        }
    }
}
